const isMobile = window.innerWidth < 400;
const isDesktop = window.innerWidth > 1000;

export { isMobile, isDesktop };
